import './PreventiveDetailsCard.scss';

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

import { useEffect } from "react";

import { fetchPreventiveDetails } from "../../../../../slices/preventiveDetails";

const PreventiveDetailsCard = ({id}) => {
    const dispatch = useDispatch();
    const token = useSelector((state) => state.auth.token);
    const columns = useSelector((state) => state.preventiveDetails.columns);
    const data = useSelector((state) => state.preventiveDetails.data);

    useEffect(() => {
        dispatch(fetchPreventiveDetails({token, id}));
    }, [dispatch, token, id]);

    const formatValue = (value) => {
        if (Array.isArray(value)) {
            return value
                .map((item) => {
                    if (item && typeof item === "object") {
                        return Object.values(item).filter(Boolean).join(" - ");
                    }
                    return item;
                })
                .join(", ");
        }

        if (value && typeof value === "object") {
            return Object.values(value).filter(Boolean).join(" - ");
        }

        return value ?? "";
    };

    return (
        <div className={"preventive-details-card"}>
            <div className={"preventive-details-card_container"}>
                {columns.map((col) =>
                    <div key={col.key} className={"preventive-details-card_field"}>
                        <div className={"preventive-details-card_title"}>{col.alias || col.name}</div>
                        <div className={"preventive-details-card_description"}>
                            {formatValue(data.attributes[col.key])}
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}

export default PreventiveDetailsCard;